import compose from 'utils/composeEnhancer'
import useSnimationObserver from './useSnimationObserver'

export default compose(
  useSnimationObserver,
)
